// extracted by mini-css-extract-plugin
export default {"advertCardPhoto":"c-a_ho","advertCardPhoto__image":"c-a_hp"};